import {
  CUSTOMER_OWNED_PRODUCT_IDS,
  CUSTOMER_OWNED_VIEW,
  CUSTOMER_VIEW,
  EXTERNAL_IDENTITY_NAME,
  SPECIAL_ORDER_VIEW,
  STORE_VIEW,
  STORE_VIEW_SCROLL_KEY
} from './const';
import { STATUS_IDS, getStatusLabel } from './statusConfig';

interface NewStoreFormData {
  storeId?: string;
  cartId?: string;
  associateId?: string;
  storeInfo?: any;
  productId?: string;
  userInfo?: any;
  profileId?: any;
  extendedAttributes?: Array<{ name?: string; value?: string }>;

  [key: string]: unknown;
}

interface NewStoreWindow {
  auth?: { accessToken: string };
  contextProps?: { formData: NewStoreFormData };
  externalIdentity?: string;
  externalIdentities?: [{ identityProvider?: string, identity?: string }];
}

declare global {
  interface Window {
    NEWSTORE?: NewStoreWindow;
  }
}

export function getNewStoreData(): {
  accessToken: string | null;
  storeId: string | null;
  externalIdentity: string | null;
  cartId: string | null;
  productId: string | null;
  extendedAttributes: Array<{ name?: string; value?: string }>;
  associateId: string | null;
  associateEmail: string | null;
  profileId: string | null;
  associateFirstName: string | null;
  associateLastName: string | null;
  associateFullName: string | null;
} {
  const decodeJwtPayload = (token: string | null): Record<string, any> | null => {
    if (!token) return null;
    try {
      const [, payload] = token.split('.');
      if (!payload) return null;
      const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
      const padded = normalized.padEnd(normalized.length + (4 - (normalized.length % 4 || 4)) % 4, '=');
      const json = atob(padded);
      return JSON.parse(json);
    } catch {
      return null;
    }
  };

  if (!window.NEWSTORE) {
    if (window.location.hash) {
      try {
        window.NEWSTORE = JSON.parse(
          atob(window.location.hash.replace(/^#/, ''))
        );
      } catch {
        window.NEWSTORE = {};
      }
    } else {
      window.NEWSTORE = {
        auth: { accessToken: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJYYUp5Yjc3LVBjZk1WQUR5UkdMdjVEMnJpNWFxc19PaVppa1JqaTUwdDV3In0.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.N9ITxH-5QW5MXkG1InEaHmuTaq-ixNyrFCz8FhoVr0Krao2CYy7ahZRmcfp5tK-3VaG-UmsJY-RRqm7nT2OrvF7HgTMSW2ENHfvqdOmOL0-O9JXNCxTdYeVdNJzMtgDVjwX7aQIE6kbfsM-cFGPs54T7aYAGNM4ND5xF8D3O7euMO-JbI5dhJfp78OgeWji4VZMt2Y3ANa9Qn5-ULsxJ7w92w9vTwGpwrrHOIaWFEJjFcYnsfdMbcEwvaPkyMNDCq3ERZCN6vcfXQRMhd2n17yE6aSC7nWN40CZw8kDGuBFKArcFOa0opIQ_1K46cKxPUTYalCHmZrQPuRbsfirm4g' },
        externalIdentity: 'EXTERNAL_ID',
        contextProps: {
          formData: { storeId: '053', cartId: '86345bc9-20d6-4e38-b08e-c7e940c03335' },
        },
        externalIdentities: [{
          identityProvider: EXTERNAL_IDENTITY_NAME,
          identity: 'eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI0ODkxYWVlYy1jNzg1LTQ5ODUtOTY4Yy02YzA0ZGJhZDg3MDQiLCJpYXQiOjE3ODQ2MTEwODYsImV4cCI6MTc4NDY1NDI4NiwiYXNzb2NpYXRlX2xhc3RfbmFtZSI6Ik0iLCJyb2xlcyI6WyJlbmdyYXZpbmciLCJjb25zZW50Iiwic2VydmljZS1pc3MiLCJjYXNoLW1hbmFnZW1lbnQiXSwiYXNzb2NpYXRlX2VtYWlsIjoidmlnbmVzaC5tQGxpdG11czcuY29tIiwiYXNzb2NpYXRlX2lkIjoiMDVjMTM2OTIwZTJjNWNlNTliYjMxODBhZTQyNjU3MDUiLCJhc3NvY2lhdGVfZmlyc3RfbmFtZSI6IlZpZ25lc2giLCJhc3NvY2lhdGVfbmFtZSI6IlZpZ25lc2ggTSJ9.YYoPqOir9XxuWwtRVE5fapDAkLYfmnTjIjBjG7rKfUE'
        }],
      };
    }
  }

  const accessToken = window?.NEWSTORE?.auth?.accessToken ?? null;
  const externalIdentity = window?.NEWSTORE?.externalIdentities?.find(identity => EXTERNAL_IDENTITY_NAME === identity.identityProvider)?.identity ?? null;
  const identityClaims = decodeJwtPayload(externalIdentity);
  const formData = window?.NEWSTORE?.contextProps?.formData;
  const storeId = formData?.storeId ?? formData?.storeInfo?.storeId ?? null;
  const cartId = formData?.cartId ?? null;
  const productId = formData?.productId ?? null;
  const extendedAttributes = formData?.extendedAttributes ?? [];
  const profileId = formData?.profileId ?? null;
  const rawAssociateId = formData?.userInfo?.id ?? formData?.associateId ?? null;
  const rawAssociateEmail = formData?.userInfo?.email ?? null;

  const tokenAssociateId = identityClaims?.associate_id ?? null;
  const tokenAssociateEmail = identityClaims?.associate_email ?? null;
  const associateFirstName = identityClaims?.associate_first_name ?? null;
  const associateLastName = identityClaims?.associate_last_name ?? null;
  const derivedAssociateName = [associateFirstName, associateLastName]
    .filter(Boolean)
    .join(' ')
    .trim();
  const associateFullNameFromToken =
    identityClaims?.associate_name ?? (derivedAssociateName ? derivedAssociateName : null);

  const associateId = tokenAssociateId ?? rawAssociateId;
  const associateEmail = tokenAssociateEmail ?? rawAssociateEmail ?? (profileId ? rawAssociateId : null);
  const associateFullName = associateFullNameFromToken;

  return {
    accessToken,
    storeId,
    externalIdentity,
    cartId,
    productId,
    extendedAttributes,
    associateId,
    associateEmail,
    profileId,
    associateFirstName: associateFirstName ?? null,
    associateLastName: associateLastName ?? null,
    associateFullName,
  };
}

export function getView(productId: string | null, profileId: string | null): string {
  if (!productId && !profileId) {
    return STORE_VIEW;
  }

  if (profileId) {
    return CUSTOMER_VIEW;
  }

  if (CUSTOMER_OWNED_PRODUCT_IDS.split(',').includes(productId!)) {
    return CUSTOMER_OWNED_VIEW;
  }

  return SPECIAL_ORDER_VIEW;
}


export type ConsolidatedStatus = {
  key: string;               // stable key for UI
  label: string;             // Title Case
  ids: number[];             // underlying ids that will be sent as CSV
};

export const CONSOLIDATED_STATUS_OPTIONS: ConsolidatedStatus[] = [
  { key: 'OPEN', label: 'Open', ids: [STATUS_IDS.OPEN] },
  {
    key: 'WIP',
    label: 'Work In Progress',
    ids: [
      STATUS_IDS.START,
      STATUS_IDS.STOP,
      STATUS_IDS.WORK_IN_PROGRESS,
      STATUS_IDS.RECEIVED_BY_KERRVILLE,
      STATUS_IDS.WORK_IN_PROGRESS_BY_KERRVILLE,
    ],
  },
  { key: 'SHIP_TO_KERR', label: 'Shipped To Product Care', ids: [STATUS_IDS.SHIPPED_TO_KERRVILLE] },
  { key: 'SHIP_TO_STORE', label: 'Shipped To Store', ids: [STATUS_IDS.SHIPPED_TO_STORE_BY_KERRVILLE] },
  { key: 'READY_PICKUP', label: 'Ready To Pickup', ids: [STATUS_IDS.READY_TO_PICKUP] },
  { key: 'ON_HOLD', label: 'Delayed Pickup', ids: [STATUS_IDS.ON_HOLD] },
  { key: 'COMPLETED', label: 'Handover Complete', ids: [STATUS_IDS.COMPLETED] },
  { key: 'CANCELLED', label: 'Cancelled', ids: [STATUS_IDS.CANCELLED] },
];

// title-case helper for any stray strings (defensive)
export const toTitle = (s: string) =>
  s
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());

// Given a raw statusId from the backend, return the consolidated label
export const getConsolidatedStatusLabel = (id?: number | string) => {
  if (id == null) return '—';
  const n = typeof id === 'string' ? Number(id) : id;
  const group = CONSOLIDATED_STATUS_OPTIONS.find(g => g.ids.includes(n));
  return group?.label ?? getStatusLabel(n);
};

// Convert selected consolidated key to CSV string of ids
export const consolidatedKeyToCsv = (key: string) => {
  const found = CONSOLIDATED_STATUS_OPTIONS.find(s => s.key === key);
  return found ? found.ids.join(',') : '';
};

export const ALL_STATUS_IDS: number[] = Array.from(
  new Set(CONSOLIDATED_STATUS_OPTIONS.flatMap((option) => option.ids))
);

export const ALL_STATUS_IDS_CSV = ALL_STATUS_IDS.join(',');

// --- Order Type filter
export type OrderType = 'all' | 'QUICK' | 'STANDARD' | 'SPECIAL_ORDER' | 'BOPIS';

export const ORDER_TYPE_OPTIONS: { value: OrderType; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'QUICK', label: 'Quick' },
  { value: 'STANDARD', label: 'Standard' },
  { value: 'SPECIAL_ORDER', label: 'Special Order' },
  { value: 'BOPIS', label: 'BOPIS-BOSS' },
];

export type OrderAge =
  | 'all'
  | '21'
  | '30'
  | '60'
  | '90';
  
export const ORDER_AGE_OPTIONS = [
    { value: 'all', label: 'All' },
    { value: '21', label: 'Older than 21 days' },
    { value: '30', label: 'Older than 30 days' },
    { value: '60', label: 'Older than 60 days' },
    { value: '90', label: 'Older than 90 days' },
];

export type SortBy =
  | 'CREATED_NEWEST'
  | 'CREATED_OLDEST'
  | 'CUSTOMER_NAME_ASC'
  | 'CUSTOMER_NAME_DESC';

export const SORT_OPTIONS = [
  {
    value: 'CREATED_NEWEST',
    label: 'Created Date (Newest First)',
  },
  {
    value: 'CREATED_OLDEST',
    label: 'Created Date (Oldest First)',
  },
  {
    value: 'CUSTOMER_NAME_ASC',
    label: 'Customer Name (A–Z)',
  },
  {
    value: 'CUSTOMER_NAME_DESC',
    label: 'Customer Name (Z–A)',
  },
] as const;
export const SORT_MAPPING: Record<
  SortBy,
  {
    sortBy: 'created' | 'customer_name';
    sortOrder: 'asc' | 'desc';
  }
> = {
  CREATED_NEWEST: {
    sortBy: 'created',
    sortOrder: 'desc',
  },
  CREATED_OLDEST: {
    sortBy: 'created',
    sortOrder: 'asc',
  },
  CUSTOMER_NAME_ASC: {
    sortBy: 'customer_name',
    sortOrder: 'asc',
  },
  CUSTOMER_NAME_DESC: {
    sortBy: 'customer_name',
    sortOrder: 'desc',
  },
};

interface StoreViewScrollState {
  restoreScroll: boolean;
  scrollY: number;
  loadedCount: number;
  page:number;
}

export const getScrollState = (): StoreViewScrollState | null => {
  try {
    const value = sessionStorage.getItem(STORE_VIEW_SCROLL_KEY);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};
export const saveScrollState = (state: StoreViewScrollState) => {
  sessionStorage.setItem(
    STORE_VIEW_SCROLL_KEY,
    JSON.stringify(state)
  );
};
export const clearScrollState = () => {
  sessionStorage.removeItem(STORE_VIEW_SCROLL_KEY);
};
export const UPS_TRACKING_PREFIX_REGEX = /^1Z/i;
export type ShipmentGroup = {
  id: string;
  trackingReference: string;
  serviceItemIds: string[];
};